module.exports = __webpack_public_path__ + "static/coffeeLogo-3aa2d34710957f6dd63788d64b3e715c.svg";